import { render } from "./App.vue?vue&type=template&id=1570be9c"
const script = {}

import exportComponent from "/home/runner/work/login/login/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__